import { BiLingualValue } from 'types/common'
import { Language } from 'types/language'

export const AB_NEWS_ARTICLE_SLUG: BiLingualValue<string> = {
  [Language.DUTCH]: 'bolt-en-ab-slaan-de-handen-in-elkaar',
  [Language.FRENCH]: 'bolt-et-ab-un-partenariat-rythme'
}

export const AB_SIMULATION_SALES_OFFICE = 'ancienne-belgique'
